var API_BASE_URL = process.env.GLYDER_API_BASE_URL || "https://api.glyder.dev";
// var API_BASE_URL = process.env.GLYDER_API_BASE_URL || "http://localhost:8888";

export { API_BASE_URL };
